import React, { useContext } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { OrçamentosContext } from 'contexts/OrçamentosContext';
import { DropsContext } from 'contexts/DropsContext';
import { GridContext } from 'contexts/GridContext';
import { useModal } from 'components/Modals';
import ResumoModal from 'components/Modals/ResumoModal';
import Container from 'components/Container';
import Header from 'components/Header';
import Card from 'components/Card';
import Grid from 'components/Grid';
import Filter from './filter';
import mock from './mock';

const Orçamentos = () => {
  const rotina = 'Orçamentos';
  const navigate = useNavigate();
  const { openModal } = useModal();
  const { drops } = useContext(DropsContext);
  const { exportPdf, exportXls } = useContext(GridContext);
  const { orçamentos, getOrçamentos, getLoading } =
    useContext(OrçamentosContext);
  const { control, getValues, reset } = useForm({
    defaultValues: orçamentos?.filter,
  });

  const loadGrid = (props) => {
    if (props?.replace) {
      reset();
    }
    getOrçamentos({ ...props, rotina, filter: getValues() });
  };

  const options = [
    {
      name: 'Adicionar Orçamento',
      icon: 'add',
      action: () => navigate('/app/Orcamentos/Gerar'),
    },
    {
      name: 'Exportar PDF',
      icon: 'file_download',
      action: () =>
        exportPdf({ rotina, filter: getValues(), order: orçamentos?.order }),
    },
    {
      name: 'Exportar XLS',
      icon: 'file_download',
      action: () =>
        exportXls({ rotina, filter: getValues(), order: orçamentos.order }),
    },
    {
      name: 'Resumo',
      icon: 'summarize',
      action: () =>
        openModal(
          <ResumoModal
            colunas={orçamentos?.colunas}
            onSubmit={(group) =>
              navigate('/app/Resumo', {
                state: { rotina, group, filter: getValues() },
              })
            }
          />
        ),
    },
  ];
  const rowOptions = [
    {
      name: 'Aprovação necessária',
      icon: 'priority_high',
      color: 'secondary.main',
      show: ({ row }) => row?.aprovacao === 'PENDENTE',
    },
    {
      name: 'Aprovado',
      icon: 'check',
      color: 'primary.main',
      show: ({ row }) => row?.aprovacao === 'SIM',
    },
    {
      name: ' Reprovado',
      icon: 'close',
      color: 'secondary.main',
      show: ({ row }) => row?.aprovacao === 'NAO',
    },
    {
      name: 'Detalhes',
      icon: 'visibility',
      action: ({ row }) => navigate(`/app/Documento/${row?.id}`),
    },
  ];

  return (
    <Container>
      <Header rotina={rotina} colunas={orçamentos?.colunas} />
      <Card>
        <Grid
          grid={orçamentos}
          mock={mock}
          options={options}
          rowOptions={rowOptions}
          control={control}
          checkboxSelection
          loading={getLoading}
          loadGrid={loadGrid}
          activeFilter={(getActiveFilter) => getActiveFilter(getValues())}
          FilterComponent={
            <Filter grid={orçamentos} control={control} drops={drops} />
          }
        />
      </Card>
    </Container>
  );
};

export default Orçamentos;
